<div style="background-color: black">
  <div
    class="container d-flex justify-content-between align-items-center flex-wrap py-1"
  >
    <a
      href="https://www.india.gov.in/"
      style="
        display: flex;
        align-items: center;
        text-decoration: none;
        margin: 5px;
      "
      target="_blank"
    >
      <img
        src="/assets/images/inidan-flag-img.png"
        height="22"
        alt="Government Logo"
      />
      <p class="govofindia">Government of India</p>
    </a>

    <div class="d-flex align-items-center flex-wrap">
      <a href="#" class="topatag">Skip to Main Content</a>
      <!-- <a href="#" class="topatag">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="21"
          height="21"
          viewBox="0 0 21 21"
          fill="none"
        >
          <mask
            id="mask0_121_506"
            style="mask-type: alpha"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="21"
            height="21"
          >
            <rect x="0.266602" y="0.5" width="20" height="20" fill="#D9D9D9" />
          </mask>
          <g mask="url(#mask0_121_506)">
            <path
              d="M3.85638 18.4166C3.44078 18.4166 3.08581 18.2695 2.79148 17.9751C2.49713 17.6808 2.34996 17.3258 2.34996 16.9102V4.08975C2.34996 3.67415 2.49713 3.31919 2.79148 3.02486C3.08581 2.73051 3.44078 2.58333 3.85638 2.58333H10.7554L9.5054 3.83331H3.85638C3.78159 3.83331 3.72015 3.85736 3.67206 3.90544C3.62398 3.95352 3.59994 4.01496 3.59994 4.08975V16.9102C3.59994 16.985 3.62398 17.0464 3.67206 17.0945C3.72015 17.1426 3.78159 17.1666 3.85638 17.1666H12.5102C12.585 17.1666 12.6464 17.1426 12.6945 17.0945C12.7426 17.0464 12.7666 16.985 12.7666 16.9102V14.875H14.0166V16.9102C14.0166 17.3258 13.8694 17.6808 13.5751 17.9751C13.2807 18.2695 12.9258 18.4166 12.5102 18.4166H3.85638ZM5.47496 15.2916V14.0417H10.8916V15.2916H5.47496ZM5.47496 12.8878V11.6378H9.22492V12.8878H5.47496ZM12.5583 12.5753L9.52142 9.53844H7.14163V5.78846H9.52142L12.5583 2.75163V12.5753ZM14.2249 10.3221V5.00481C14.6875 5.29113 15.0462 5.67227 15.301 6.14823C15.5559 6.62419 15.6833 7.12926 15.6833 7.66344C15.6833 8.19762 15.5545 8.7027 15.297 9.17867C15.0396 9.65463 14.6822 10.0358 14.2249 10.3221ZM14.2249 13.7532V12.4359C15.1384 12.0566 15.8876 11.4319 16.4725 10.5617C17.0574 9.6915 17.3499 8.72541 17.3499 7.66344C17.3499 6.60148 17.0574 5.63541 16.4725 4.76521C15.8876 3.89502 15.1384 3.27028 14.2249 2.891V1.57373C15.4877 1.97544 16.5326 2.73666 17.3595 3.85738C18.1864 4.9781 18.5999 6.24679 18.5999 7.66344C18.5999 9.08011 18.1864 10.3488 17.3595 11.4695C16.5326 12.5902 15.4877 13.3515 14.2249 13.7532Z"
              fill="white"
            />
          </g>
        </svg>
        Screen Reader
      </a> -->

      <!-- <div class="topatag">
        <a href="#" class="topfontsize">A-</a>
        <a href="#" class="topfontsize">A</a>
        <a href="#" class="topfontsize">A+</a>
      </div> -->

      <!-- <a href="#" class="topatag" style="border: none">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="25"
          height="25"
          viewBox="0 0 25 25"
          fill="none"
        >
          <path
            d="M12.2666 20.8334C16.869 20.8334 20.5999 17.1025 20.5999 12.5001C20.5999 7.89771 16.869 4.16675 12.2666 4.16675C7.66422 4.16675 3.93326 7.89771 3.93326 12.5001C3.93326 17.1025 7.66422 20.8334 12.2666 20.8334ZM12.2666 19.5834V5.41675C16.1786 5.41675 19.3499 8.58806 19.3499 12.5001C19.3499 16.4121 16.1786 19.5834 12.2666 19.5834Z"
            fill="#EBEBEB"
          />
        </svg>
      </a> -->

      <div class="translate">
        <div id="google_translate_element"></div>
      </div>
    </div>
  </div>
</div>
